import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useLang } from '../context/LangContext';
import { creatorImages } from '../mock/data';

const Testimonials = () => {
  const { t } = useLang();

  return (
    <section className="py-24 md:py-32 bg-neutral-50">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-14">
          <span className="inline-block text-[13px] font-bold tracking-widest uppercase text-amber-600 mb-4">{t.testimonials.sectionLabel}</span>
          <h2 className="text-[40px] md:text-[56px] font-black tracking-[-0.02em] leading-[1.05] text-neutral-900">{t.testimonials.title}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.testimonials.items.map((tst, i) => (
            <div key={i} className="bg-white rounded-3xl p-6 border border-neutral-200/70 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
              <Quote className="w-8 h-8 text-neutral-200" strokeWidth={1.5} />
              <p className="mt-4 text-[15px] leading-relaxed text-neutral-800 font-medium min-h-[100px]">“{tst.text}”</p>
              <div className="mt-5 flex items-center gap-3 pt-5 border-t border-neutral-100">
                <img src={creatorImages[i % creatorImages.length]} alt={tst.name} className="w-11 h-11 rounded-full object-cover" />
                <div>
                  <div className="text-[14px] font-bold text-neutral-900">{tst.name}</div>
                  <div className="text-[11.5px] text-neutral-500 font-medium">{tst.role}</div>
                </div>
              </div>
              <div className="mt-3 flex gap-0.5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
